<div class="social-links-block">
  @for (item of links(); track item.link) {
    <a [href]="item.link" class="menu-item" target="_blank" rel="nofollow">
      <span class="icon" [class]="item.icon"></span>
    </a>
  }
</div>
